<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">VALÉRIE BATIGNE</p>
                        <p class="green">Dirigeante d’entreprise à Paris (75)</p>
                    </figcaption>
                </figure>
                <p class="number" :class="item.color">
                    8 174
                </p>
                <p class="green uppercase semiBold">
                    plans épargne retraite individuel (PERin) ouverts par Groupama au 31 décembre
                    2019, trois mois seulement après son lancement.
                </p>
                <!--<img class="icono w300" :src="require('../../assets/t3-assurance-vie.jpg')">-->
                <p class="label green">
                    LA CAGNOTTE HUG
                </p>
                <p class="green uppercase semiBold">
                    Un programme de récompense en partenariat avec Paylead qui permet d'épargner sans effort pour sa
                    retraite.

                </p>
                <iframe width="560" height="200" src="https://www.youtube.com/embed/rZPlhR_qht8" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                <img class="icono w300" :src="require('../../assets/ambre.jpg')">
                <p class="label green">
                    GROUPAMA AMBRE 2019
                </p>
                <p class="green uppercase semiBold">
                    Une solution d’épargne polyvalente adaptée à tous les âges de la vie proposée par Groupama
                    Asfalistiki en Grèce.
                    <br/>

                </p>


            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>Rendre accessible à tous le conseil et l’accompagnement retraite.</h2>
                <h1>
                    <span>Agir aux côtés</span>
                    <span>DE VALÉRIE ET DE TOUS </span>
                    <span>nos <em :class="item.color">PARTENAIRES POUR LES</em></span>
                    <span><em :class="item.color">ACTUELS ET FUTURS</em></span>
                    <span><em :class="item.color">RETRAITÉS ET ÉPARGNANTS</em></span>
                </h1>
                <!--
                                <h3>
                                    à la tête d'une exploitation<br>
                                    de 350 HA, en blé, colza et orge
                                </h3>-->

                <p>
                    Valérie Batigne, est une spécialiste reconnue des systèmes de retraite. En 2015, elle a fondé
                    <span class="marker" :class="item.color">Sapiendo Retraite</span>, une plateforme innovante de
                    conseil qui allie « la performance d’une solution digitale, unique dans le secteur, aux compétences
                    d’une équipe de consultants en matière de bilan, de conseil et d’information retraite. » Une double
                    approche très utile sur le marché.<br>
                    <br>
                    En France, la retraite est en effet au cœur des préoccupations de tous les Français. Qu’ils soient
                    en âge de toucher leur pension ou qu’ils s’y préparent, ils sont encore peu nombreux à être
                    accompagnés sur le sujet alors que la retraite représente aujourd’hui 14 % du PIB hexagonal.<br>
                    <br>
                    A l’origine avocate spécialisée en droit fiscal, social et règlementaire, Valérie a saisi
                    l’opportunité de ce « vide très français », comme elle le désigne, pour créer en 2010 son cabinet
                    conseil, un des rares acteurs privés dans le domaine de la retraite par répartition.<br>
                    <br>
                    En 2015, portée par la volonté de rendre le service qu’elle avait créé plus accessible en utilisant des
                    techniques innovantes, Valérie a digitalisé son offre pour traiter efficacement les données de ses
                    clients tout en maintenant un accompagnement humain.<br>
                    <br>
                    En 2017, alors que la question des pensions n’était pas une préoccupation aussi forte
                    qu’aujourd’hui, Groupama a eu la volonté d’accélérer le développement de son offre retraite.
                    Groupama a été parmi les premiers à comprendre l’intérêt de mieux penser la retraite par répartition
                    en amont de la retraite par capitalisation. Une ambition qui a favorisé le partenariat entre
                    Sapiendo et le Groupe : l’idée étant d’éclairer les Français sur la globalité de leurs pensions et
                    de les accompagner au mieux.<br>
                    <br>
                    Sapiendo est aujourd’hui un service multiforme proposé aux clients et sociétaires de Groupama. Ils
                    ont accès gratuitement à une première analyse détaillée de leur retraite. Une offre qui peut être
                    complétée d’un service payant à un tarif très compétitif comme la vérification du relevé retraite ou
                    l’édition de courriers de régularisation prêts à être envoyés aux caisses de retraites.<br>
                    <br>
                    Retrouvez plus d’informations sur <strong>Sapiendo Retraite</strong> en cliquant <a target="_blank" href="https://www.sapiendo-retraite.fr">ici</a> et sur la plateforme <strong>Ma nouvelle vie commence ici</strong> en cliquant
                    <a target="_blank" href="https://manouvellevie.groupama.fr">ici</a>
                </p>

                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>Retrouvez tous les faits qui ont marqué notre année</p>
                        <p><span>Télécharger</span> le rapport annuel</p>
                    </div>
                </a>

            </section>
        </article>

    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if (!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
